var render = function render(){var _vm=this,_c=_vm._self._c;return _c('EmptyView',{attrs:{"name":_vm.t('spreed', 'The conversation does not exist'),"description":_vm.t('spreed', 'Join a conversation or start a new one!')},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('IconMagnify')]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }